// extracted by mini-css-extract-plugin
module.exports = {"StatusText":"InvoiceStatus_StatusText__3eJ2x","StatusSubText":"InvoiceStatus_StatusSubText__Bs0Ne","StatusLabel":"InvoiceStatus_StatusLabel__3kJ2L"};